<div *ngIf="descriptor">
    <div [style.display]="search ? 'block' : 'none'">

        <mat-card class="m-b-15">
            <mat-card-content>

                <vedrax-search-autocomplete [searchForm]="searchForm" [filters]="filters">
                </vedrax-search-autocomplete>

                <div class="vedrax-viewer-list">
                    <mat-selection-list multiple=false>
                        <cdk-virtual-scroll-viewport itemSize="30" [style.height.px]="visibleOptions * 30">
                            <mat-list-option *cdkVirtualFor="let option of datasource" (click)="select(option)">
                                {{option.value}}
                            </mat-list-option>
                        </cdk-virtual-scroll-viewport>
                    </mat-selection-list>
                </div>
            </mat-card-content>
            <mat-card-footer>
                <div class="vedrax-search-list-footer">
                    <button mat-button mat-icon-button aria-label="Back" (click)="closeSearch()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <mat-spinner *ngIf="submitted" diameter="20"></mat-spinner>
                </div>
            </mat-card-footer>
        </mat-card>

    </div>

    <div [style.display]="search ? 'none' : 'block'">
        <mat-form-field *ngIf="selected">
            <button *ngIf="selected.key" mat-button matPrefix mat-icon-button aria-label="clear"
                (click)="clearSearch()">
                <mat-icon>clear</mat-icon>
            </button>
            <mat-label>{{descriptor.controlLabel}}</mat-label>
            <input readonly matInput type="text" [ngModel]="selected.value">
            <button mat-button matSuffix mat-icon-button aria-label="Edit" (click)="openSearch()">
                <mat-icon>manage_search</mat-icon>
            </button>
            <mat-error>
                <vedrax-validation [control]="formControl" [validations]="descriptor.controlValidations">
                </vedrax-validation>
            </mat-error>
        </mat-form-field>
    </div>
</div>